import { SsMount } from 'src/js/dom/mount.js';
import { SsThreadHead } from 'src/js/dom/thread-head.js';

export class SsThreadItem extends SsMount {
  accordionize () {
    new SsThreadHead( this.elm.querySelector( '.thread-head' ) )
      .init()
      .setAccord( this.elm.querySelector( '.thread-accord' ) )
      .onClick();
  }
}
